export const consts = {
    BASE_END_POINT: getBaseUrl() + 'controllers' 
    //BASE_END_POINT: 'http://localhost:11956/' + 'controllers'
    // For remote testing, use: 'https://test.capnsub.com/controllers'
    // For remote testing, use: 'https://beta.capnsub.com/controllers'
    // For production, use: 'https://www.capnsub.com/v1/controllers'
}

function getBaseUrl() {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
    return baseUrl;
}
    


// WEBPACK FOOTER //
// ./app/helpers/consts.js